import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import sideImg from '../assets/images/BudhhaCrop.jpg'; 
import { FaTimes } from 'react-icons/fa'; 
import API from './Api';
import { toast } from 'react-toastify';
const Register = () => {
    const navigate = useNavigate();
    
    // Controlled form attributes matching your Django user master model sequence
    const [formData, setFormData] = useState({
        name: '', 
        mobileno: '', 
        residence: '', 
        emailid: '',
        gender: '', 
        dob: '', 
        location: ''
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false); // 💡 Tracks api submission status

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validate = () => {
        let tempErrors = {};
        const mobileRegex = /^[0-9]{10}$/;
        
        if (!formData.mobileno) {
            tempErrors.mobileno = "Contact No is required.";
        } else if (!mobileRegex.test(formData.mobileno)) {
            tempErrors.mobileno = "Contact No must be exactly 10 digits.";
        }
        
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        if (validate()) {
            setLoading(true); // 💡 FIX 1: Turn loading indicator ON to capture all inputs fields securely
            try {
                const response = await API.post('register/', formData);
                
                if (response.status === 201 || response.data.status === "Success" || response.status === 200) {
                    toast.success("Registration successful! Please check your email to set your password.");
                    navigate('/TGSH/login');
                }
            } catch (error) {
                console.error("Registration processing error log:", error);
               toast.error(error.response?.data?.error || error.response?.data?.detail || "Registration failed. Please verify credentials.");
            } finally {
                setLoading(false); // 💡 FIX 2: Turn loading indicator OFF post execution sequence
            }
        }
    };

    return (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/85 backdrop-blur-sm p-4 overflow-y-auto">
            <div className="bg-white w-full max-w-6xl rounded-[32px] shadow-[0_20px_80px_rgba(0,0,0,0.25)] overflow-hidden flex flex-col lg:flex-row border border-white/20 relative">
                {/* --- Close Button --- */}
                <button 
                    onClick={() => navigate('/TGSH')} 
                    className="absolute top-5 right-5 z-50 text-gray-400 transition-colors p-2 bg-gray-100 rounded-full md:bg-transparent border-none cursor-pointer"
                    title="Close"
                >
                    <FaTimes className="text-xl" />
                </button>

                {/* Form Section */}
                <div className="w-full lg:w-3/5 p-5 sm:p-8 md:p-10 lg:p-12 overflow-y-auto max-h-[90vh]">
                    <div className="mb-8">
                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#032167]">
                            Create Account
                        </h2>

                        <p className="text-gray-500 mt-2 text-sm sm:text-base">
                            Join The Global School Of Happiness
                        </p>
                    </div>
                    
                    <form onSubmit={handleRegister} className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                        <div className="md:col-span-2">
                            <label className="text-[11px] uppercase font-bold text-gray-400">Full Name</label>
                            <input type="text" name="name" placeholder="Enter full name" value={formData.name} onChange={handleChange} required className="w-full border border-gray-200 px-4 py-3 bg-gray-50 focus:bg-white focus:border-[#54a50f] focus:ring-2 focus:ring-[#54a50f]/20 outline-none transition-all" />
                        </div>

                        <div>
                            <label className="text-[11px] uppercase font-bold text-gray-400">Contact No</label>
                            <input 
                                type="text" 
                                name="mobileno" 
                                placeholder="10 Digits" 
                                value={formData.mobileno}
                                onChange={handleChange} 
                                maxLength="10" 
                                onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) { e.preventDefault(); }
                                }}
                                required 
                                className="w-full border border-gray-200 px-4 py-3 bg-gray-50 focus:bg-white focus:border-[#54a50f] focus:ring-2 focus:ring-[#54a50f]/20 outline-none transition-all"
                            />
                            {errors.mobileno && <p className="text-red-500 text-[10px] mt-1 font-bold">{errors.mobileno}</p>}
                        </div>

                        <div>
                            <label className="text-[11px] uppercase font-bold text-gray-400">Residence</label>
                            <select name="residence" value={formData.residence} onChange={handleChange} required className="w-full border-b-2 border-gray-100 p-2 focus:border-[#54a50f] outline-none bg-transparent text-sm font-bold text-gray-700 cursor-pointer">
                                <option value="">Select Residence</option>
                                <option value="India">Indian</option>
                                <option value="Other Country">Other Country</option>
                            </select>
                        </div>

                        <div className="md:col-span-2">
                            <label className="text-[11px] uppercase font-bold text-gray-400">Email Address</label>
                            <input type="email" name="emailid" placeholder="example@gmail.com" value={formData.emailid} onChange={handleChange} required className="w-full border-b-2 border-gray-100 p-2 focus:border-[#54a50f] outline-none text-sm lowercase font-mono" />
                        </div>

                        <div>
                            <label className="text-[11px] uppercase font-bold text-gray-400">Gender</label>
                            <select name="gender" value={formData.gender} onChange={handleChange} required className="w-full border-b-2 border-gray-100 p-2 focus:border-[#54a50f] outline-none bg-transparent text-sm font-bold text-gray-700 cursor-pointer">
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>

                        <div>
                            <label className="text-[11px] uppercase font-bold text-gray-400">Date Of Birth</label>
                            <input type="date" name="dob" value={formData.dob} onChange={handleChange} required className="w-full border-b-2 border-gray-100 p-2 focus:border-[#54a50f] outline-none text-sm text-gray-600 font-semibold cursor-pointer" />
                        </div>

                        <div className="md:col-span-2">
                            <label className="text-[11px] uppercase font-bold text-gray-400">Current Location</label>
                            <input type="text" name="location" placeholder="City, Country" value={formData.location} onChange={handleChange} required className="w-full border-b-2 border-gray-100 p-2 focus:border-[#54a50f] outline-none text-sm normal-case font-medium" />
                        </div>

                        <div className="md:col-span-2 pt-4">
                            {/* 💡 FIX 3: Disabled button during active network state execution to block data losses */}
                            <button 
                                type="submit" 
                                disabled={loading}
                                className="w-full md:w-auto
                                bg-gradient-to-r
                                from-[#54a50f]
                                to-[#3d7a0b]
                                hover:scale-[1.02]
                                text-white
                                font-bold
                                py-4
                                px-12
                                rounded-2xl
                                shadow-xl
                                uppercase
                                tracking-widest
                                transition-all
                                duration-300
                                disabled:bg-gray-400
                                "
                            >
                                {loading ? "Creating Account..." : "Create Account"}
                            </button>
                        </div>
                    </form>

                    <p className="mt-8 text-[13px] text-gray-500">
                        Already registered? <span onClick={() => navigate('/TGSH/login')} className="text-[#032167] font-bold cursor-pointer hover:underline">Sign In</span>
                    </p>
                </div>

                {/* Right Side: Image Section */}
                <div className="
                    w-full
                    lg:w-2/5
                    h-52
                    sm:h-72
                    lg:h-auto
                    bg-[#f8fcf5]
                    flex
                    items-center
                    justify-center
                    p-4
                    order-first
                    lg:order-last
                ">
                    <div className="relative w-full h-full rounded-2xl overflow-hidden shadow-2xl">
                        <img
                            src={sideImg}
                            alt="Buddha"
                            className="
                            w-full
                            h-full
                            object-contain
                            rounded-2xl
                            shadow-xl
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;